interface BalanceIconProps {
  className?: string;
  size?: number;
}

export function BalanceIcon({ className = 'w-6 h-6', size }: BalanceIconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={size}
      height={size}
    >
      {/* Outer circle */}
      <circle cx="12" cy="12" r="11" stroke="currentColor" strokeWidth="1.5" />
      {/* Inner ring */}
      <circle cx="12" cy="12" r="8.5" stroke="currentColor" strokeWidth="1" opacity="0.5" />
      {/* Lightning bolt */}
      <path
        d="M13.5 4.5L9 13h3l-1.5 6.5L16 11h-3.5l1-6.5z"
        fill="currentColor"
      />
    </svg>
  );
}
